import { createContext } from "react";
import type { CustomExerciseActionsContextType } from "../ExercisesProvider.types";

const CustomExercisesActionsContext = createContext<CustomExerciseActionsContextType | undefined>(undefined);
CustomExercisesActionsContext.displayName = "CustomExercisesActionsContext";

export default CustomExercisesActionsContext;
